import React from 'react';
import Icon from '@material-ui/icons/VisibilityOff';

const VisibilityOff = (props) => <Icon {...props} />;

export default VisibilityOff;
